<template>
  <div class="main">
    <el-container>
      <!-- <el-header height="100px">大树联合集团网站后台管理系统
        <div class="quit" @click="quit">退出登录</div>
      </el-header> -->
        <el-aside width="200px">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            :router="true"
            @open="handleOpen"
            @close="handleClose"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"> 
            <div class="logoimf"><img src="../../assets/dashu/backlogin.png" width="70%" alt=""></div>
            <el-menu-item index="/backChildren"><i class="el-icon-folder"></i>新闻中心</el-menu-item>
            <el-menu-item index="/newtype"><i class="el-icon-folder"></i>新闻类型</el-menu-item>
            <el-menu-item index="/services"><i class="el-icon-folder"></i>我们的服务</el-menu-item> 
            <el-menu-item index="/backContact"><i class="el-icon-folder"></i>关于我们</el-menu-item>
            <el-menu-item index="/backJoin"><i class="el-icon-folder"></i>加入我们</el-menu-item> 
            <el-menu-item index="/backRecruit"><i class="el-icon-s-custom"></i>招聘列表</el-menu-item>
            <el-submenu index="1"><template slot="title"><i class="el-icon-setting"></i><span>网站设置</span>
                </template>
              <el-menu-item index="/backSEO">SEO设置</el-menu-item>
            </el-submenu>
            <el-menu-item index="/backBanner"><i class="el-icon-s-tools"></i>Banner设置</el-menu-item>
          </el-menu>
        </el-aside>
      <el-container>
        <!-- 侧边导航 -->
          <el-header height="100px">大树联合集团网站后台管理系统
            <div class="quit" @click="quit">退出登录</div>
          </el-header>
          <el-main>
            <router-view/>
            <!-- <Backfooter></backfooter> -->
          </el-main>
          <!-- <el-footer>
            <Backfooter></backfooter>
          </el-footer> -->
            <!-- <Backfooter></backfooter> -->

      </el-container>
    </el-container>
  </div>
  </template>
<script>
import Backfooter from '../../components/dashu/backfooter';
export default {
  components:{Backfooter,},
  data() {
    return{
      thisRouter: ''
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    quit(){
         this.$confirm('即将退出登录, 是否继续?', '提示', {
          confirmButtonText: '继续退出',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.localStorage.removeItem("user_token");
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          this.$router.push("/backLogin")
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消退出'
          });          
        });
    }
  } ,
  created() {
    this.$http.post('/admin/dashu/banner/getInfo', {id:4}, {
          headers: {
            Authorization: window.localStorage.getItem('user_token')
          }
        }).then(res => {
      if (res.data.code == -2) {
        this.$router.push({ name: 'backLogin' })
      }
    })
  }
}
</script>

<style >
html, body, #app, .main {
  height: 100%;
}
.el-header {
  background-color: white;
  color: #333;
  text-align: center;
  line-height: 100px;
  font-family: 'Microsoft YaHei';
  font-size: 24px;
  border-bottom: 2px solid #b2b2b2;
}
.el-aside {
  background-color: rgb(84, 92, 100);
  color: #333;
  text-align: center;
  line-height: 200px;
}
.el-container {
  height: 100%;
}
.el-main {
  background-color: #E9EEF3;
  color: #333;
  padding: 20px 20px 0px !important;
  /* text-align: center; */
  /* line-height: 160px; */
  position: relative;
} 

/* .el-pagination {
    padding: 2px 5px 195px !important;
    } */
.breadcrumb {
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 30px;
  color: black;
  background: white;
  padding: 10px;
  box-shadow: 0 2px 1px 1px rgba(99,99,99,.1);
}
.quit{
    float: right;
    font-size: 16px

}
.quit:hover{
  cursor: pointer;
}
.el-menu{
  border:none ;
}
.logoimf {
    width: 200px;
    height: 80px;
    position: relative;
}
.logoimf img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
} 
</style>



// WEBPACK FOOTER //
// src/pages/backPages/home.vue